<div class="no-data flex column align-center">
  <app-no-data-img></app-no-data-img>
  <app-no-data-label [noDataTitle]="noDataTitle" [noDataSubtitle]="noDataSubtitle"></app-no-data-label>
</div>
